import React, { useRef } from 'react';
import { useFirstTimeVisible } from '../../../components/shared/hooks/useFirstTimeVisible';
import { supporters } from '../../../assets/sponsors';
import sanofi from '../../../assets/sponsors/sanofi.png';

const Sponsors = ({ onSectionIsVisible }) => {
  const ref = useRef();
  const isVisible = useFirstTimeVisible(ref, onSectionIsVisible);

  return (
    <div className="content-section section-hcp-sponsors">
      <div className="content-text-wrapper">
        <h2 className="about-titles about-titles__center title__black100">
          EczemaWise Sponsors
        </h2>

        <p className="about-paragraph about-paragraph__center" ref={ref}>
          Thank you to these generous sponsors for unrestricted educational
          grants in support of EczemaWise.
        </p>

        <div className="sponsors-list">
          <img
            className="sponsor-logo big"
            src={sanofi}
            alt="Sanofi"
            title="Sanofi"
          />
        </div>
      </div>
    </div>
  );
};

export default Sponsors;
